/* eslint-disable */
const mutations = {
  setAvailabilities(state, { availabilities }) {
    state.data = availabilities;
  },
};

export default mutations;
